import "@babylonjs/core/Debug/debugLayer";
import "@babylonjs/inspector";
import "@babylonjs/loaders/glTF";
import { Engine, Scene, ArcRotateCamera, Vector3, HemisphericLight,
    Mesh, MeshBuilder, Camera, UniversalCamera, FreeCamera } from "@babylonjs/core";

import * as GUI from "@babylonjs/gui";
import { World } from "./world"

class App {
    constructor() {
        // create the canvas html element and attach it to the webpage
        var canvas = document.createElement("canvas");
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.id = "gameCanvas";
        document.body.appendChild(canvas);

        // initialize babylon scene and engine
        var engine = new Engine(canvas, true);
        var scene = new Scene(engine);

        // scene.useRightHandedSystem = true;

        let mapCenter = new Vector3(World.SIZE / 2, 0, World.SIZE / 2)
        var camera: ArcRotateCamera = new ArcRotateCamera("Camera", Math.PI / 3, Math.PI / 3, 3 * 10, mapCenter, scene);

        camera.lowerRadiusLimit = camera.radius;
        camera.upperRadiusLimit = camera.radius;
        camera.upperBetaLimit = (4 * Math.PI) / 10;
        camera.lowerBetaLimit = 0;

        //   camera.upperAlphaLimit = Math.PI;
        //   camera.lowerAlphaLimit = 0;

        camera.wheelDeltaPercentage = 0.01;
        camera.mode = Camera.ORTHOGRAPHIC_CAMERA;
        camera.attachControl(canvas, true);
        let width = 10 * 1.5;

        camera.orthoLeft = (-1.2 * width) / 2;
        camera.orthoRight = -camera.orthoLeft;
        const ratio = canvas.height / canvas.width;
        if (camera.orthoLeft && camera.orthoRight) {
            camera.orthoTop = camera.orthoRight * ratio;
            camera.orthoBottom = camera.orthoLeft * ratio;
        }

        var light1: HemisphericLight = new HemisphericLight("light1", new Vector3(1, 1, 0), scene);

        let world: World = new World(scene);
        globalThis.world = world;

        // create the UI control panel
        this.createUI(scene, world);

        // hide/show the Inspector
        window.addEventListener("keydown", (ev) => {
            // Shift+Ctrl+Alt+I
            if (ev.ctrlKey && ev.key === 'i') {
                if (scene.debugLayer.isVisible()) {
                    scene.debugLayer.hide();
                } else {
                    scene.debugLayer.show();
                }
            }
        });


        // run the main render loop
        engine.runRenderLoop(() => {
            scene.render();
        });
    }

    createUI(scene, world) {
        // Create a fullscreen UI for the buttons
        var advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");

        // Create a vertical stack panel to hold the buttons
        var panel = new GUI.StackPanel();
        panel.width = "300px";
        panel.fontSize = "14px";
        panel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        panel.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        advancedTexture.addControl(panel);

        // Create a radio button group
        var radioGroup = new GUI.StackPanel();
        radioGroup.isVertical = true;
        radioGroup.width = "300px";
        radioGroup.height = "300px";
        radioGroup.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        radioGroup.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        advancedTexture.addControl(radioGroup);

        // Helper function to create radio buttons
        const createRadioButton = (group, text, color, background, isChecked, callback) => {
            var radioButton = new GUI.RadioButton();
            radioButton.group = group;
            radioButton.width = "20px";
            radioButton.height = "20px";
            radioButton.color = color;
            radioButton.background = background;
            radioButton.isChecked = isChecked;
            radioButton.onIsCheckedChangedObservable.add(callback);
            var header = GUI.Control.AddHeader(radioButton, text, "200px", { isHorizontal: true, controlFirst: true });
            header.height = "30px";
            header.color = "white";
            radioGroup.addControl(header);
        };

        // Create radio buttons
        createRadioButton("mode", "Move Cart", "white", "green", true, (state) => {
            if (state) {
                console.log("Mode changed to Move Cart");
                world.mode = "move cart";
            }
        });

        createRadioButton("mode", "Select Goal Track", "white", "blue", false, (state) => {
            if (state) {
                world.mode = "find path";
                console.log("Mode changed to Select Goal Track");
            }
        });

        createRadioButton("track", "Straight Track", "white", "green", true, (state) => {
            if (state) {
                console.log("Track changed to Straight Track");
                world.trackType = "straight";
            }
        });

        // TODO: Simplify the track types for now to just straight and turntable
        // createRadioButton("track", "Curved Track", "white", "blue", false, (state) => {
        //     if (state) {
        //         console.log("Track changed to Curved Track");
        //         world.trackType = "curved";
        //     }
        // });

        // createRadioButton("track", "Rotatable Right Angle Track", "white", "green", false, (state) => {
        //     if (state) {
        //         console.log("Track changed to Rotatable Right Angle Track");
        //         world.trackType = "rotatable";
        //     }
        // });

        createRadioButton("track", "Rotatable Straight Track", "white", "blue", false, (state) => {
            if (state) {
                console.log("Track changed to Rotatable Straight Track");
                world.trackType = "rotatable straight";
            }
        });
        

        // // Helper function to create buttons
        // const createButton = (name, text, color, background, callback) => {
        //     var button = GUI.Button.CreateSimpleButton(name, text);
        //     button.width = "200px";
        //     button.height = "40px";
        //     button.color = color;
        //     button.background = background;
        //     button.onPointerUpObservable.add(callback);
        //     panel.addControl(button);
        // };

        // // Create buttons
        // createButton("but1", "Button 1", "white", "green", () => {
        //     console.log("Button 1 clicked");
        // });

        // createButton("but2", "Button 2", "white", "blue", () => {
        //     console.log("Button 2 clicked");
        // });
    }
}
new App();